import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React from 'react';
import { useReducedMotion } from '@mantine/hooks';
import { ChevronIcon } from './ChevronIcon.js';
import useStyles from './AccordionItem.styles.js';
import { Box } from '../../Box/Box.js';
import { UnstyledButton } from '../../Button/UnstyledButton/UnstyledButton.js';
import { Center } from '../../Center/Center.js';
import { Collapse } from '../../Collapse/Collapse.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return target;
};

function AccordionItem(_a) {
  var _b = _a,
      opened = _b.opened,
      onToggle = _b.onToggle,
      label = _b.label,
      children = _b.children,
      className = _b.className,
      classNames = _b.classNames,
      styles = _b.styles,
      transitionDuration = _b.transitionDuration,
      _b$icon = _b.icon,
      icon = _b$icon === void 0 ? /* @__PURE__ */React.createElement(ChevronIcon, null) : _b$icon,
      _b$disableIconRotatio = _b.disableIconRotation,
      disableIconRotation = _b$disableIconRotatio === void 0 ? false : _b$disableIconRotatio,
      _b$offsetIcon = _b.offsetIcon,
      offsetIcon = _b$offsetIcon === void 0 ? true : _b$offsetIcon,
      _b$iconSize = _b.iconSize,
      iconSize = _b$iconSize === void 0 ? 24 : _b$iconSize,
      _b$iconPosition = _b.iconPosition,
      iconPosition = _b$iconPosition === void 0 ? "left" : _b$iconPosition,
      _b$order = _b.order,
      order = _b$order === void 0 ? 3 : _b$order,
      id = _b.id,
      controlRef = _b.controlRef,
      onControlKeyDown = _b.onControlKeyDown,
      others = __objRest(_b, ["opened", "onToggle", "label", "children", "className", "classNames", "styles", "transitionDuration", "icon", "disableIconRotation", "offsetIcon", "iconSize", "iconPosition", "order", "id", "controlRef", "onControlKeyDown"]);

  var reduceMotion = useReducedMotion();
  var duration = reduceMotion ? 0 : transitionDuration;

  var _useStyles = useStyles({
    transitionDuration: duration,
    disableIconRotation: disableIconRotation,
    iconPosition: iconPosition,
    offsetIcon: offsetIcon,
    iconSize: iconSize
  }, {
    classNames: classNames,
    styles: styles,
    name: "Accordion"
  }),
      classes = _useStyles.classes,
      cx = _useStyles.cx;

  var cappedOrder = Math.min(6, Math.max(2, order));
  var Heading = "h".concat(cappedOrder);
  return /* @__PURE__ */React.createElement(Box, __spreadValues({
    className: cx(classes.item, _defineProperty({}, classes.itemOpened, opened), className)
  }, others), /* @__PURE__ */React.createElement(Heading, {
    className: classes.itemTitle
  }, /* @__PURE__ */React.createElement(UnstyledButton, {
    className: classes.control,
    onClick: onToggle,
    type: "button",
    "aria-expanded": opened,
    "aria-controls": "".concat(id, "-body"),
    id: id,
    ref: controlRef,
    onKeyDown: onControlKeyDown
  }, /* @__PURE__ */React.createElement(Center, {
    className: classes.icon
  }, icon), /* @__PURE__ */React.createElement("div", {
    className: classes.label
  }, label))), /* @__PURE__ */React.createElement(Collapse, {
    in: opened,
    transitionDuration: duration
  }, /* @__PURE__ */React.createElement("div", {
    className: classes.content,
    role: "region",
    id: "".concat(id, "-body"),
    "aria-labelledby": id
  }, /* @__PURE__ */React.createElement("div", {
    className: classes.contentInner
  }, children))));
}

AccordionItem.displayName = "@mantine/core/AccordionItem";
export { AccordionItem };